module.exports = __webpack_public_path__ + "img/illus_setup_1@2x.7a9a1e7a.png";